import './App.css'

export default function Home() {
    return (
        <div className="container">
            <div className="card">
                <h1 className="title">Coming Soon</h1>
                <p className="subtitle">
                    This website is currently being built.
                </p>

                <div className="loader"></div>

                <p className="footer">
                    Please check back later
                </p>
            </div>
        </div>
    )
}